import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import type { ReactNode } from 'react';

import { oidcConfig } from '@/lib/auth/keycloakConfig';

import { AuthAdapter } from './AuthAdapter';

interface AuthProviderProps {
    children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
    return (
        <OidcAuthProvider {...oidcConfig}>
            <AuthAdapter>{children}</AuthAdapter>
        </OidcAuthProvider>
    );
}
